import { render } from "./batchReturnModel.vue?vue&type=template&id=715b8f29"
import script from "./batchReturnModel.vue?vue&type=script&lang=js"
export * from "./batchReturnModel.vue?vue&type=script&lang=js"

import "./batchReturnModel.vue?vue&type=style&index=0&id=715b8f29&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__